import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  typographyStyle: {
    fontfamily: 'Lato',
    color: 'grey',
    fontSize: '1.5rem',
    textAlign: 'left',
    fontWeight: 400,
  }
});


export const Blog = (props) => {
  const classes = useStyles();
  return (
    <div id='blog'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>Hear what is going on</h2>
        </div>
          {props.data? props.data.map((d, i) => (
          <Accordion>
              <AccordionSummary
                key={`${d.date}-${i}`}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.typographyStyle}>{d.date}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className={classes.typographyStyle}>
                  {d.text}
                </Typography>
              </AccordionDetails>
        </Accordion>
          )) : "loading"}
      </div>
    </div>
  )
}
